//----------------------------------------------------
// FotoUploadMetPintura.jsx — Werkbon foto-editor
//----------------------------------------------------
import { useState } from "react";
import {
  openDefaultEditor,
  setPlugins,
  plugin_crop,
  plugin_annotate,
  plugin_filter,
  plugin_resize,
} from "@pqina/pintura";

import locale_nl_NL from "@pqina/pintura/locale/nl_NL";
import api from "../../services/api";

import "@pqina/pintura/pintura.css";


setPlugins(
  plugin_crop,
  plugin_annotate,
  plugin_filter,
  plugin_resize
);


export default function FotoUploadMetPintura({
  werkbonId,
  onClose,
  onSaved,
}) {

  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(null);


  // ===============================
  // Select + edit
  // ===============================
  const handleFileChange = async (event) => {

    const file = event.target.files[0];
    if (!file) return;

    try {

      // Open editor
      const edited = await openDefaultEditor({
        src: URL.createObjectURL(file),
        locale: locale_nl_NL,

        imageWriter: {
          mimeType: "image/jpeg",
          quality: 0.9,
        },
      });

      if (!edited || !edited.dest) return;

      // Preview
      setPreview(edited.dest);

      // Blob maken
      const blob = await fetch(edited.dest).then((r) => r.blob());

      const formData = new FormData();

      formData.append("fotos", blob, file.name);


      // Upload
      setUploading(true);

      await api.post(
        `/werkbonnen/${werkbonId}/fotos`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      onSaved();

    } catch (err) {

      console.error("Upload fout:", err);
      alert(err?.response?.data?.message || "Upload mislukt");

    } finally {

      setUploading(false);
    }
  };


  // ===============================
  // UI
  // ===============================
  return (

    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">

      <div className="bg-white rounded-xl shadow-xl p-5 w-full max-w-xl">


        {/* Header */}
        <div className="flex justify-between mb-3">

          <h3 className="font-bold text-lg">
            Foto bewerken
          </h3>

          <button onClick={onClose}>✖</button>

        </div>


        {/* Input */}
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          disabled={uploading}
        />


        {/* Status */}
        {uploading && (
          <p className="text-blue-600 mt-2">
            Uploaden...
          </p>
        )}


        {/* Preview */}
        {preview && (

          <img
            src={preview}
            alt="preview"
            className="mt-3 rounded border"
          />

        )}


        {/* Footer */}
        <div className="flex justify-end mt-4">

          <button
            onClick={onClose}
            className="border px-3 py-1 rounded"
          >
            Sluiten
          </button>

        </div>

      </div>

    </div>
  );
}
